module.exports = __webpack_public_path__ + "media/images/logo_white-9af0bbbc1ab824bf831e7c7ff25c3484.png";